const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import textMap from './translations';
import ECheckinForm from 'App/config/ukbb/eCheckin/ECheckinForm';
import Footer from 'App/config/ukbb/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'en'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.ukbb.ch/',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beruf: 'Lookup/979e0eb4-5b41-433f-a953-fd5d18e0aac7/Children',
        Beziehung: 'Lookup/5be10476-ebbf-4e4c-9f06-7bc060208a4b/Children',
        Geschlecht: 'Lookup/96958055-c62d-4069-9ab8-a2ad6d55dc82/Children',
        Zivilstand: 'Lookup/776c7597-c48d-4569-91ee-1b0bafd562ed/Children',
        Behandlungsgrund: 'Lookup/f2e3c5a1-e430-490a-bbe8-eb4f4fca0c40/Children',
        Versicherung: 'Lookup/35ebb0fd-68db-42c2-b686-f27bab5c151b/Children',
        Klasse: 'Lookup/c9da4555-44ec-470d-a3bf-0d3dc93c1583/Children',
        Language: 'Lookup/8dd57a4c-2f35-4404-ba68-5b2d7c7218c8/Children',
        Religion: 'Lookup/a2711141-95fc-4d66-b1bf-960fdbda672f/Children',
        Versicherungen: 'Lookup/bc1233c8-dc24-4087-a553-d02e5e744f9e/Children',
    },
    customMatomoClientId: 6,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
